var map = {
	"./af.json": 837,
	"./am.json": 838,
	"./ar.json": 839,
	"./az.json": 840,
	"./be.json": 841,
	"./bg.json": 842,
	"./bn.json": 843,
	"./bs.json": 844,
	"./ca.json": 845,
	"./cs.json": 846,
	"./cy.json": 847,
	"./da.json": 848,
	"./de.json": 849,
	"./dv.json": 850,
	"./el.json": 851,
	"./en.json": 852,
	"./es.json": 853,
	"./et.json": 854,
	"./eu.json": 855,
	"./fa.json": 856,
	"./fi.json": 857,
	"./fr.json": 858,
	"./gl.json": 859,
	"./ha.json": 860,
	"./he.json": 861,
	"./hi.json": 862,
	"./hr.json": 863,
	"./hu.json": 864,
	"./hy.json": 865,
	"./id.json": 866,
	"./is.json": 867,
	"./it.json": 868,
	"./ja.json": 869,
	"./ka.json": 870,
	"./kk.json": 871,
	"./km.json": 872,
	"./ko.json": 873,
	"./ku.json": 874,
	"./ky.json": 875,
	"./lt.json": 876,
	"./lv.json": 877,
	"./mk.json": 878,
	"./ml.json": 879,
	"./mn.json": 880,
	"./ms.json": 881,
	"./nb.json": 882,
	"./nl.json": 883,
	"./nn.json": 884,
	"./no.json": 885,
	"./pl.json": 886,
	"./ps.json": 887,
	"./pt.json": 888,
	"./ro.json": 889,
	"./ru.json": 890,
	"./sd.json": 891,
	"./sk.json": 892,
	"./sl.json": 893,
	"./so.json": 894,
	"./sq.json": 895,
	"./sr.json": 896,
	"./sv.json": 897,
	"./sw.json": 898,
	"./ta.json": 899,
	"./tg.json": 900,
	"./th.json": 901,
	"./tr.json": 902,
	"./tt.json": 903,
	"./ug.json": 904,
	"./uk.json": 905,
	"./ur.json": 906,
	"./uz.json": 907,
	"./vi.json": 908,
	"./zh.json": 909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;